import { SBModel } from '@supplement-bacon/react-toolkit/models'

/**
 * Extension as per Instagram specifications
 *
 * https://developers.facebook.com/docs/instagram-platform/instagram-api-with-instagram-login/messaging-api#send-an-image-or-gif
 */

export interface AttachmentType extends SBModel {
  name: string
  extensions: Array<string>
  maxSize: number
  accept: Array<string>
}

export type FileType = 'pdf' | 'picture' | 'video' | 'audio'
export const attachmentTypes: Record<FileType, AttachmentType> = {
  pdf: {
    id: 3,
    name: 'PDF',
    extensions: ['pdf'],
    maxSize: 8000000, // 4Mo
    accept: ['application/pdf'],
  },
  picture: {
    id: 0,
    name: 'Picture',
    extensions: ['png', 'jpeg', 'heic'],
    maxSize: 4194304, // 4Mb
    accept: ['image/png', 'image/jpeg', 'image/heic'],
  },
  video: {
    id: 1,
    name: 'Video',
    extensions: ['mp4', 'ogg', 'avi', 'mov', 'webm'],
    maxSize: 26214400, // 25Mb
    accept: [
      'video/mp4',
      'video/ogg',
      'video/x-msvideo',
      'video/quicktime',
      'video/webm',
    ],
  },
  audio: {
    id: 2,
    name: 'Audio',
    extensions: ['aac', 'm4a', 'waw', 'mp4'],
    maxSize: 26214400, // 25Mb
    accept: ['audio/aac', 'audio/mp4', 'audio/wav', 'audio/mp4'],
  },
}

export const formatBytes = (bytes: number): string => {
  const units = ['octets', 'Ko', 'Mo', 'Go', 'To']
  let index = 0

  while (bytes >= 1024 && index < units.length - 1) {
    bytes /= 1024
    index++
  }

  return `${bytes.toFixed(0)} ${units[index]}`
}
